import { inject, Injectable, signal } from "@angular/core";
import { get } from "lodash";
import { PasswordFlowMode } from "./passwordflowmode";
import { ServiceInjector } from "../classes/infrastructure/injector";
import { SidebarMenuStateService } from "./sidebarmenustateservice";

@Injectable({
  providedIn: "root",
})
export class AppStateManageService {
  public static GetInstance(): AppStateManageService {
    return ServiceInjector.AppInjector.get(AppStateManageService);
  }
  private SidebarMenuStateService = inject(SidebarMenuStateService);

  private CurrentCompanyRef = 0;
  private CurrentCompanyName = "";
  private CompanyRef = 0;

  private EmployeeRef = 0;
  private LoginToken = "";

  private CurrentGAAProjectRefForProductVersion = 0;
  private CurrentGAAProjectNameForProductVersion = "";

  private CurrentGAAProjectRefForProductInputChannel = 0;
  private CurrentGAAProjectNameForProductInputChannel = "";

  private CurrentGAAProjectRefForProductOutputChannel = 0;
  private CurrentGAAProjectNameForProductOutputChannel = "";

  private CustomerName = "";
  private CustomerRef = 0;

  private DepartmentName = 0;
  private DepartmentRef = 0;
  private DesignationRef = 0;

  // private GAAProjectName = '';
  private projectCount = 0;
  private Theme = "";
  public readonly StorageKey = sessionStorage;
  // public readonly localStorage = localStorage;

  public devUserId: string = "deployment@gladiance.com";
  public devPassword: string = "maths@4321";
  private IsForgetPasswordClickedValue = false;
  public isDropdownDisabled = signal<boolean>(false);

  private AppLanguage = "";

  private RootFamilyRef = 0;
  private NoOfFamilies = 0;
  private IsRootFamily = false;

  // private _BaseImageUrl: string = "http://192.168.29.68:5000/uploads/";

  // public get BaseImageUrl(): string {
  //   return this._BaseImageUrl;
  // }

  constructor() { }

  setDropdownDisabled(value: boolean) {
    this.isDropdownDisabled.set(value);
  }

  // EmployeeRef  start
  getEmployeeRef(): number {
    const EmployeeRef = this.StorageKey.getItem("EmployeeRef");
    return EmployeeRef ? +EmployeeRef : 0; // Return the Employee reference or 0 if not found
  }
  setEmployeeRef(val: number): void {
    this.EmployeeRef = val;
    this.StorageKey.setItem("EmployeeRef", val.toString()); // Store Employee reference in local storage
  }
  resetEmployeeRef(): void {
    this.StorageKey.setItem("EmployeeRef", "0");
  }

  setSiteRef(value: number, Name: string) {
    this.StorageKey.setItem("siteRf", value.toString());
    this.StorageKey.setItem("siteName", Name);
  }

  resetSiteRef(): void {
    this.StorageKey.setItem("siteRf", "0");
    this.StorageKey.setItem("siteName", "");
  }

  // Chapter  start
  ChapterRef: number = 0;
  getChapterRef(): number {
    const ChapterRef = this.StorageKey.getItem("SelectedChapterRef");
    return ChapterRef ? +ChapterRef : 0; // Return the Chapter reference or 0 if not found
  }
  setChapterRef(val: number): void {
    this.ChapterRef = val;
    this.StorageKey.setItem("SelectedChapterRef", val.toString()); // Store Chapter reference in local storage
  }
  resetChapterRef(): void {
    this.StorageKey.setItem("SelectedChapterRef", "0");
  }

  // Sub Chapter  start
  SubChapterRef: number = 0;
  getSubChapterRef(): number {
    const SubChapterRef = this.StorageKey.getItem("SelectedSubChapterRef");
    return SubChapterRef ? +SubChapterRef : 0; // Return the SubChapter reference or 0 if not found
  }
  setSubChapterRef(val: number): void {
    this.SubChapterRef = val;
    this.StorageKey.setItem("SelectedSubChapterRef", val.toString()); // Store SubChapter reference in local storage
  }
  resetSubChapterRef(): void {
    this.StorageKey.setItem("SelectedSubChapterRef", "0");
  }

  // ----------- Chapter Name Start
  chapteromerName: string = "";
  getChapterName(): string {
    const chapterName = this.StorageKey.getItem("SelectedChapterName");
    return chapterName ? chapterName : ""; // Return the SelectedChapterName reference or 0 if not found
  }

  setSubChapterName(val: string): void {
    this.chapteromerName = val;
    this.StorageKey.setItem("SelectedChapterName", val); // Store SelectedChapterName reference in local storage
  }

  resetChapterName(): void {
    this.StorageKey.setItem("SelectedChapterName", "");
  }
  //---------- Chapter Name End

  // ----------- subchapteromer Name Start
  getCustomerName(): string {
    const custName = this.StorageKey.getItem("CustomerName");
    return custName ? custName : ""; // Return the project reference or 0 if not found
  }

  setCustomerName(val: string): void {
    this.CustomerName = val;
    this.StorageKey.setItem("CustomerName", val); // Store project reference in local storage
  }

  resetCustomerName(): void {
    this.StorageKey.setItem("CustomerName", "");
  }
  //---------- Customer Name End

  // ----------- Theme Start
  getTheme(): string {
    const theme = this.StorageKey.getItem("Theme");
    return theme ? theme : "dark";
  }

  setTheme(val: string): void {
    this.Theme = val;
    this.StorageKey.setItem("Theme", val);
  }

  resetTheme(): void {
    this.StorageKey.setItem("Theme", "");
  }
  //---------- Theme End--------------

  // ValidMenuItemIds2
  getValidMenuItemIds2 = () => {
    const strMenuItemIds = this.StorageKey.getItem("ValidMenuItemIds2");
    return strMenuItemIds ? (JSON.parse(strMenuItemIds) as string[]) : [];
  };

  setValidMenuItemIds2 = (value: string[]) => {
    this.StorageKey.setItem("ValidMenuItemIds2", JSON.stringify(value));
  };

  clearValidMenuItemIds2 = () => {
    this.StorageKey.removeItem("ValidMenuItemIds2");
    this.StorageKey.removeItem("siteRf");
    this.StorageKey.removeItem("siteName");
    this.StorageKey.removeItem("bookingremarkRef");
  };

  // //--------- project Ref Start

  //---------- UserJSON
  getUserJSON(): Object | null {
    const UserJSON = this.StorageKey.getItem("UserJSON");
    return UserJSON; // Return the UserJSON or 0 if not found
  }

  setUserJSON(val: Object | null): void {
    this.StorageKey.setItem("UserJSON", JSON.stringify(val)); // Store UserJSON reference in local storage
  }

  resetUserJSON(): void {
    this.StorageKey.setItem("UserJSON", "0");
  }

  // for Current and Privious Month
  Months: number[] = [];
  getMonths(): number[] {
    const months = this.StorageKey.getItem("Months");
    return months ? JSON.parse(months) : [];
  }

  setMonths(val: number[]): void {
    this.Months = val;
    this.StorageKey.setItem("Months", JSON.stringify(val));
  }
  resetMonths(): void {
    this.Months = [];
    this.StorageKey.removeItem("Months");
  }

  // for Role
  Role: number = 0;
  getRole(): number {
    // const Role = this.storageKey.getItem("Role");
    const Role = this.SidebarMenuStateService.getRole();
    return Role ? +Role : 0; // Return the Company reference or 0 if not found
  }
  setRole(val: number): void {
    this.Role = val;
    this.StorageKey.setItem("Role", val.toString()); // Store Company reference in local storage
  }
  resetRole(): void {
    this.StorageKey.setItem("Role", "0");
  }

  // for Post Ref
  PostRef: number = 0;
  getPostRef(): number {
    // const PostRef = this.storageKey.getItem("PostRef");
    const PostRef = this.SidebarMenuStateService.getPostRef();
    return PostRef ? +PostRef : 0; // Return the Company reference or 0 if not found
  }
  setPostRef(val: number): void {
    this.PostRef = val;
    this.StorageKey.setItem("PostRef", val.toString()); // Store Company reference in local storage
  }
  resetPostRef(): void {
    this.StorageKey.setItem("PostRef", "0");
  }

  // for UnderSupervisionPostRef
  UnderSupervisionPostRef: number = 0;
  getUnderSupervisionPostRef(): number {
    // const UnderSupervisionPostRef = this.StorageKey.getItem(
    //   "UnderSupervisionPostRef"
    // );
    const UnderSupervisionPostRef = this.SidebarMenuStateService.getUnderSupervisionPostRef();
    return UnderSupervisionPostRef ? +UnderSupervisionPostRef : 0; // Return the Company reference or 0 if not found
  }
  setUnderSupervisionPostRef(val: number): void {
    this.UnderSupervisionPostRef = val;
    this.StorageKey.setItem("UnderSupervisionPostRef", val.toString()); // Store Company reference in local storage
  }
  resetUnderSupervisionPostRef(): void {
    this.StorageKey.setItem("UnderSupervisionPostRef", "0");
  }

  // for Role
  RoleName: string = "";
  getRoleName(): string {
    // const RoleName = this.StorageKey.getItem("RoleName");
    const RoleName = this.SidebarMenuStateService.getRolename();
    return RoleName ? RoleName : ""; // Return the Company reference or 0 if not found
  }

  setRoleName(val: string): void {
    this.RoleName = val;
    // this.StorageKey.setItem("RoleName", val); // Store Company reference in local storage
  }
  resetRoleName(): void {
    this.StorageKey.setItem("RoleName", "");
  }

  // for User Display Name

  UserDisplayName: string = "";
  getUserDisplayName(): string {
    const getUserDisplayName = this.StorageKey.getItem("UserDisplayName");

    return getUserDisplayName ? getUserDisplayName : ""; // Return the Company reference or 0 if not found
  }

  setUserDisplayName(val: string): void {
    this.UserDisplayName = val;
    this.StorageKey.setItem("UserDisplayName", val); // Store Company reference in local storage
  }
  resetUserDisplayName(): void {
    this.StorageKey.setItem("UserDisplayName", "");
  }

  // for LoginUserRef
  LoginUserRef: number = 0;
  getLoginUserRef(): number {
    // const LoginUserRef = this.StorageKey.getItem("LoginUserRef");
    const LoginUserRef = this.SidebarMenuStateService.getUserRef();
    return LoginUserRef ? LoginUserRef : 0; // Return the Company reference or 0 if not found
  }
  setLoginUserRef(val: number): void {
    this.LoginUserRef = val;
    this.StorageKey.setItem("LoginUserRef", val.toString()); // Store Company reference in local storage
  }
  resetLoginUserRef(): void {
    this.StorageKey.setItem("LoginUserRef", "0");
  }

  // for Department Ref End

  getDesignationRef(): number {
    const DesignationRef = this.StorageKey.getItem("DesignationRef");
    return DesignationRef ? +DesignationRef : 0; // Return the Company reference or 0 if not found
  }
  setDesignationRef(val: number): void {
    this.DesignationRef = val;
    this.StorageKey.setItem("DesignationRef", val.toString()); // Store Company reference in local storage
  }
  resetDesignationRef(): void {
    this.StorageKey.setItem("DesignationRef", "0");
  }

  // ==================================== Login Token Start =========================================================

  getLoginToken(): string {
    const logtoken = this.StorageKey.getItem("CurrentLoginToken");
    // const logtoken = this.SidebarMenuStateService.getToken();
    return logtoken ? logtoken : ""; // Return the project reference or 0 if not found
  }

  setLoginToken(val: string): void {
    this.LoginToken = val;
    this.StorageKey.setItem("LoginToken", val); // Store project reference in local storage
  }

  resetLoginToken(): void {
    this.StorageKey.setItem("LoginToken", "");
  }

  //Login User Profile Image
  
  getProfileImage(): string {
    const ProfileImage = this.StorageKey.getItem("ProfileImage");
    // const logtoken = this.SidebarMenuStateService.getToken();
    return ProfileImage ? ProfileImage : ""; // Return the project reference or 0 if not found
  }

  setProfileImage(val: string): void {
    this.StorageKey.setItem("ProfileImage", val);
  }

  resetProfileImage(): void {
    this.StorageKey.setItem("ProfileImage", "");
  }

  // for District Ref
  DistrictRef: number = 0;
  getDistrictRef(): number {
    const DistrictRef = this.SidebarMenuStateService.getDistrictRef();
    return DistrictRef ? DistrictRef : 0;
  }
  setDistrictRef(val: number): void {
    this.DistrictRef = val;
    this.StorageKey.setItem("DistrictRef", val.toString());
  }
  resetDistrictRef(): void {
    this.StorageKey.setItem("DistrictRef", "0");
  }

  // for Block Ref
  BlockRef: number = 0;
  getBlockRef(): number {
    const BlockRef = this.SidebarMenuStateService.getBlockRef();
    return BlockRef ? BlockRef : 0;
  }
  setBlockRef(val: number): void {
    this.BlockRef = val;
    this.StorageKey.setItem("BlockRef", val.toString());
  }
  resetBlockRef(): void {
    this.StorageKey.setItem("BlockRef", "0");
  }

  // for PHC Ref
  PHCRef: number = 0;
  getPHCRef(): number {
    const PHCRef = this.SidebarMenuStateService.getPHCRef();
    return PHCRef ? PHCRef : 0;
  }
  setPHCRef(val: number): void {
    this.PHCRef = val;
    this.StorageKey.setItem("PHCRef", val.toString());
  }
  resetPHCRef(): void {
    this.StorageKey.setItem("PHCRef", "0");
  }

  // ==================================== Login Token End =========================================================
  // ==================================== Department start =========================================================
  getDepartmentRef(): number {
    const DepartmentRef = this.StorageKey.getItem("DepartmentRef");
    return DepartmentRef ? +DepartmentRef : 0; // Return the Company reference or 0 if not found
  }
  setDepartmentRef(val: number): void {
    this.DepartmentRef = val;
    this.StorageKey.setItem("DepartmentRef", val.toString()); // Store Company reference in local storage
  }
  resetDepartmentRef(): void {
    this.StorageKey.setItem("DepartmentRef", "0");
  }
  // ==================================== Department End =================================================================

  // ==================================== Password Mode Start ============================================================
  private readonly PASSWORD_FLOW_KEY = 'PASSWORD_FLOW_MODE';

  setPasswordFlowMode(mode: PasswordFlowMode): void {
    this.StorageKey.setItem(this.PASSWORD_FLOW_KEY, mode);
  }

  getPasswordFlowMode(): PasswordFlowMode | null {
    return this.StorageKey.getItem(this.PASSWORD_FLOW_KEY) as PasswordFlowMode;
  }

  clearPasswordFlowMode(): void {
    this.StorageKey.removeItem(this.PASSWORD_FLOW_KEY);
  }
  // ==================================== Password Mode Start End ========================================================

  // For State Maintain Functionality 
  // ==================================== Asha Training Role Start ========================================================
  private AshaTrainingRoleTypeRef = 0;
  private AshaHRRoleTypeRef = 0;

  private TrainingGroupRef = 0;
  private GrievanceGroupRef = 0;
  private PerformanceIndicatorGroupRef = 0;

  private HBNCGroupRef = 0;
  private HBYCGroupRef = 0;
  private HBYCUntrainedGroupRef = 0;
  private MotherMeetingGroupRef = 0;

  private BirthSpacingGroupRef = 0;
  private IodineGroupRef = 0;
  private RajyashasanMandhanRoleRef = 0;
  private VisitFormRoleRef = 0;
  private CurrentFamilyRef = 0;
  private CurrentFamilyRefs: number[] = [];
  private ParentFamilyRef = 0;

  // ==================================== Asha Training Role Start ========================================================
  getAshaTrainingRoleTypeRef(): number {
    const AshaTrainingRoleTypeRef = this.StorageKey.getItem('AshaTrainingRoleTypeRef');
    return AshaTrainingRoleTypeRef ? +AshaTrainingRoleTypeRef : 0; // Return the project reference or 0 if not found
  }
  setAshaTrainingRoleTypeRef(val: number): void {
    this.AshaTrainingRoleTypeRef = val;
    this.StorageKey.setItem('AshaTrainingRoleTypeRef', val.toString()); // Store project reference in local storage
  }
  resetAshaTrainingRoleTypeRef(): void {
    this.StorageKey.setItem('AshaTrainingRoleTypeRef', '0');
  }
  // ==================================== Asha Training Role End ========================================================

  // ==================================== Asha Hr Role start ========================================================

  getAshaHRRoleTypeRef(): number {
    const AshaHRRoleTypeRef = this.StorageKey.getItem('AshaHRRoleTypeRef');
    return AshaHRRoleTypeRef ? +AshaHRRoleTypeRef : 0; // Return the project reference or 0 if not found
  }
  setAshaHRRoleTypeRef(val: number): void {
    this.AshaHRRoleTypeRef = val;
    this.StorageKey.setItem('AshaHRRoleTypeRef', val.toString()); // Store project reference in local storage
  }
  resetAshaHRRoleTypeRef(): void {
    this.StorageKey.setItem('AshaHRRoleTypeRef', '0');
  }
  // ==================================== Asha HR Role End ========================================================

  // ==================================== TrainingGroupRef start ========================================================
  getTrainingGroupRef(): number {
    const TrainingGroupRef = this.StorageKey.getItem('TrainingGroupRef');
    return TrainingGroupRef ? +TrainingGroupRef : 0; // Return the project reference or 0 if not found
  }
  setTrainingGroupRef(val: number): void {
    this.TrainingGroupRef = val;
    this.StorageKey.setItem('TrainingGroupRef', val.toString()); // Store project reference in local storage
  }
  resetTrainingGroupRef(): void {
    this.StorageKey.setItem('TrainingGroupRef', '0');
  }
  // ==================================== TrainingGroupRef End ========================================================

  // ==================================== GrievanceGroupRef start ========================================================
  getGrievanceGroupRef(): number {
    const GrievanceGroupRef = this.StorageKey.getItem('GrievanceGroupRef');
    return GrievanceGroupRef ? +GrievanceGroupRef : 0; // Return the project reference or 0 if not found
  }
  setGrievanceGroupRef(val: number): void {
    this.GrievanceGroupRef = val;
    this.StorageKey.setItem('GrievanceGroupRef', val.toString()); // Store project reference in local storage
  }
  resetGrievanceGroupRef(): void {
    this.StorageKey.setItem('GrievanceGroupRef', '0');
  }
  // ==================================== GrievanceGroupRef End ========================================================

  // ==================================== PerformanceIndicatorGroupRef start ========================================================
  getPerformanceIndicatorGroupRef(): number {
    const PerformanceIndicatorGroupRef = this.StorageKey.getItem('PerformanceIndicatorGroupRef');
    return PerformanceIndicatorGroupRef ? +PerformanceIndicatorGroupRef : 0; // Return the project reference or 0 if not found
  }
  setPerformanceIndicatorGroupRef(val: number): void {
    this.PerformanceIndicatorGroupRef = val;
    this.StorageKey.setItem('PerformanceIndicatorGroupRef', val.toString()); // Store project reference in local storage
  }
  resetPerformanceIndicatorGroupRef(): void {
    this.StorageKey.setItem('PerformanceIndicatorGroupRef', '0');
  }
  // ==================================== PerformanceIndicatorGroupRef End ========================================================

  // ==================================== HBNCGroupRef start ========================================================
  getHBNCGroupRef(): number {
    const HBNCGroupRef = this.StorageKey.getItem('HBNCGroupRef');
    return HBNCGroupRef ? +HBNCGroupRef : 0; // Return the project reference or 0 if not found
  }
  setHBNCGroupRef(val: number): void {
    this.HBNCGroupRef = val;
    this.StorageKey.setItem('HBNCGroupRef', val.toString()); // Store project reference in local storage
  }
  resetHBNCGroupRef(): void {
    this.StorageKey.setItem('HBNCGroupRef', '0');
  }
  // ==================================== HBNCGroupRef End ========================================================

  // ==================================== HBYCGroupRef start ========================================================
  getHBYCGroupRef(): number {
    const HBYCGroupRef = this.StorageKey.getItem('HBYCGroupRef');
    return HBYCGroupRef ? +HBYCGroupRef : 0; // Return the project reference or 0 if not found
  }
  setHBYCGroupRef(val: number): void {
    this.HBYCGroupRef = val;
    this.StorageKey.setItem('HBYCGroupRef', val.toString()); // Store project reference in local storage
  }
  resetHBYCGroupRef(): void {
    this.StorageKey.setItem('HBYCGroupRef', '0');
  }
  // ==================================== HBYCGroupRef End ========================================================

  // ==================================== HBYCUntrainedGroupRef start ========================================================
  getHBYCUntrainedGroupRef(): number {
    const HBYCUntrainedGroupRef = this.StorageKey.getItem('HBYCUntrainedGroupRef');
    return HBYCUntrainedGroupRef ? +HBYCUntrainedGroupRef : 0; // Return the project reference or 0 if not found
  }
  setHBYCUntrainedGroupRef(val: number): void {
    this.HBYCUntrainedGroupRef = val;
    this.StorageKey.setItem('HBYCUntrainedGroupRef', val.toString()); // Store project reference in local storage
  }
  resetHBYCUntrainedGroupRef(): void {
    this.StorageKey.setItem('HBYCUntrainedGroupRef', '0');
  }
  // ==================================== HBYCUntrainedGroupRef End ========================================================

  // ==================================== MotherMeetingGroupRef start ========================================================
  getMotherMeetingGroupRef(): number {
    const MotherMeetingGroupRef = this.StorageKey.getItem('MotherMeetingGroupRef');
    return MotherMeetingGroupRef ? +MotherMeetingGroupRef : 0; // Return the project reference or 0 if not found
  }
  setMotherMeetingGroupRef(val: number): void {
    this.MotherMeetingGroupRef = val;
    this.StorageKey.setItem('MotherMeetingGroupRef', val.toString()); // Store project reference in local storage
  }
  resetMotherMeetingGroupRef(): void {
    this.StorageKey.setItem('MotherMeetingGroupRef', '0');
  }
  // ==================================== MotherMeetingGroupRef End ========================================================

  // ==================================== BirthSpacingGroupRef start ========================================================
  getBirthSpacingGroupRef(): number {
    const BirthSpacingGroupRef = this.StorageKey.getItem('BirthSpacingGroupRef');
    return BirthSpacingGroupRef ? +BirthSpacingGroupRef : 0; // Return the project reference or 0 if not found
  }
  setBirthSpacingGroupRef(val: number): void {
    this.BirthSpacingGroupRef = val;
    this.StorageKey.setItem('BirthSpacingGroupRef', val.toString()); // Store project reference in local storage
  }
  resetBirthSpacingGroupRef(): void {
    this.StorageKey.setItem('BirthSpacingGroupRef', '0');
  }
  // ==================================== BirthSpacingGroupRef End ========================================================

  // ==================================== IodineGroupRef start ========================================================
  getIodineGroupRef(): number {
    const IodineGroupRef = this.StorageKey.getItem('IodineGroupRef');
    return IodineGroupRef ? +IodineGroupRef : 0; // Return the project reference or 0 if not found
  }
  setIodineGroupRef(val: number): void {
    this.IodineGroupRef = val;
    this.StorageKey.setItem('IodineGroupRef', val.toString()); // Store project reference in local storage
  }
  resetIodineGroupRef(): void {
    this.StorageKey.setItem('IodineGroupRef', '0');
  }
  // ==================================== IodineGroupRef End ========================================================

  // ==================================== Rajyashasan Mandhan start ========================================================
  getRajyashasanMandhanRoleRef(): number {
    const RajyashasanMandhanRoleRef = this.StorageKey.getItem('RajyashasanMandhanRoleRef');
    return RajyashasanMandhanRoleRef ? +RajyashasanMandhanRoleRef : 0; // Return the project reference or 0 if not found
  }
  setRajyashasanMandhanRoleRef(val: number): void {
    this.RajyashasanMandhanRoleRef = val;
    this.StorageKey.setItem('RajyashasanMandhanRoleRef', val.toString()); // Store project reference in local storage
  }
  resetRajyashasanMandhanRoleRef(): void {
    this.StorageKey.setItem('RajyashasanMandhanRoleRef', '0');
  }
  // ==================================== Rajyashasan Mandhan End ========================================================
  // ==================================== Visit Form Role Ref start ========================================================
  getVisitFormRoleRef(): number {
    const VisitFormRoleRef = this.StorageKey.getItem('VisitFormRoleRef');
    return VisitFormRoleRef ? +VisitFormRoleRef : 0; // Return the project reference or 0 if not found
  }
  setVisitFormRoleRef(val: number): void {
    this.VisitFormRoleRef = val;
    this.StorageKey.setItem('VisitFormRoleRef', val.toString()); // Store project reference in local storage
  }
  resetVisitFormRoleRef(): void {
    this.StorageKey.setItem('VisitFormRoleRef', '0');
  }
  // ==================================== Visit Form Role Ref End ========================================================
  // ==================================== Current Family Refs (array) =========================================================
  getCurrentFamilyRefs(): number[] {
    const stored = this.StorageKey.getItem("CurrentFamilyRefs");
    return stored ? JSON.parse(stored) : [];
  }

  setCurrentFamilyRefs(vals: number[]): void {
    this.StorageKey.setItem("CurrentFamilyRefs", JSON.stringify(vals));
  }

  resetCurrentFamilyRefs(): void {
    this.StorageKey.removeItem("CurrentFamilyRefs");
  }

  // ==================================== Member Refs (array) ===============================

  // ==================================== Current Family Ref =========================================================
  getCurrentFamilyRef(): number {
    const val = this.StorageKey.getItem("CurrentFamilyRef");
    return val ? +val : 0;
  }

  setCurrentFamilyRef(val: number): void {
    this.StorageKey.setItem("CurrentFamilyRef", val.toString());
  }

  resetCurrentFamilyRef(): void {
    this.StorageKey.setItem("CurrentFamilyRef", "0");
  }

  // ==================================== Current Family Refs (array) =======================
  // ==================================== Family Ref start ========================================================

  getParentFamilyRef(): number {
    const ParentFamilyRef = this.StorageKey.getItem('ParentFamilyRef');
    return ParentFamilyRef ? +ParentFamilyRef : 0; // Return the project reference or 0 if not found
  }
  setParentFamilyRef(val: number): void {
    this.ParentFamilyRef = val;
    this.StorageKey.setItem('ParentFamilyRef', val.toString()); // Store project reference in local storage
  }
  resetParentFamilyRef(): void {
    this.StorageKey.setItem('ParentFamilyRef', '0');
  }
  // ==================================== Family Ref End ========================================================
  // ==================================== Member Refs End ========================================================
  private MemberRefs: number[] = [];
  getMemberRefs(): number[] {
    const memberRefs = this.StorageKey.getItem('MemberRefs');
    return memberRefs ? JSON.parse(memberRefs) as number[] : [];
  }

  setMemberRefs(refs: number[]): void {
    this.MemberRefs = refs;
    this.StorageKey.setItem('MemberRefs', JSON.stringify(refs));
  }

  resetMemberRefs(): void {
    this.MemberRefs = [];
    this.StorageKey.setItem('MemberRefs', JSON.stringify([]));
  }
  // ==================================== Member Refs End ========================================================

  // ==================================== App Language start ========================================================

  getAppLanguage(): string {
    const logtoken = this.StorageKey.getItem("CurrentAppLanguage");
    // const logtoken = this.SidebarMenuStateService.getToken();
    return logtoken ? logtoken : ""; // Return the project reference or 0 if not found
  }

  setAppLanguage(val: string): void {
    this.AppLanguage = val;
    this.StorageKey.setItem("AppLanguage", val); // Store project reference in local storage
  }

  resetAppLanguage(): void {
    this.StorageKey.setItem("AppLanguage", "");
  }

  // ==================================== Family Ref End ========================================================
  // ==================================== Root Family Ref start ========================================================

  getRootFamilyData(): { rootFamilyRef: number, nooffamilies: number, isRootFamily: boolean } {
    const rootFamilyRef = this.StorageKey.getItem('RootFamilyRef');
    const nooffamilies = this.StorageKey.getItem('NoOfFamilies');
    const isRootFamily = this.StorageKey.getItem('IsRootFamily');

    return {
      rootFamilyRef: rootFamilyRef ? +rootFamilyRef : 0,
      nooffamilies: nooffamilies ? +nooffamilies : 0,
      isRootFamily: isRootFamily === 'true'
    };
  }
  setRootFamilyRef(val: number, nooffamilies: number, isRootFamily: boolean): void {
    this.RootFamilyRef = val;
    this.NoOfFamilies = nooffamilies;
    this.StorageKey.setItem('RootFamilyRef', val.toString()); // Store project reference in local storage
    this.StorageKey.setItem('NoOfFamilies', nooffamilies.toString()); // Store project reference in local storage
    this.StorageKey.setItem('IsRootFamily', isRootFamily.toString()); // Store project reference in local storage
  }
  resetRootFamilyData(): void {
    this.StorageKey.removeItem('RootFamilyRef');
    this.StorageKey.removeItem('NoOfFamilies');
    this.StorageKey.removeItem('IsRootFamily');

    this.RootFamilyRef = 0;
    this.NoOfFamilies = 0;
    this.IsRootFamily = false;
  }
  // ==================================== Root Family Ref End ========================================================

  // ==================================== PHC En  ========================================================
  // for PHC
  PHCNameEn: string = "";
  getPHCNameEN(): string {
    // const PHCName = this.StorageKey.getItem("PHCName");
    const PHCNameEn = this.SidebarMenuStateService.getPHCNameEN();
    return PHCNameEn ? PHCNameEn : ""; // Return the Company reference or 0 if not found
  }

  setPHCNameEn(val: string): void {
    this.PHCNameEn = val;
    this.StorageKey.setItem("PHCNameEn", val); // Store Company reference in local storage
  }
  resetPHCNameEn(): void {
    this.StorageKey.setItem("PHCNameEn", "");
  }
  // ==================================== SC En  ========================================================

  SCNameEn: string = "";
  getSCNameEN(): string {
    // const SC = this.StorageKey.getItem("SC");
    const SCEn = this.SidebarMenuStateService.getSCNameEN();
    return SCEn ? SCEn : ""; // Return the Company reference or 0 if not found
  }
  setSCNameEn(val: string): void {
    this.SCNameEn = val;
    this.StorageKey.setItem("SCNameEn", val); // Store Company reference in local storage
  }
  resetSCNameEn(): void {
    this.StorageKey.setItem("SCNameEn", "");
  }
  // ==================================== Village En  ========================================================
  VillageNameEn: string = "";
  getVillageNameEn(): string {
    // const Village = this.StorageKey.getItem("Village");
    const Village = this.SidebarMenuStateService.getVillageNameEn();
    return Village ? Village : ""; // Return the Company reference or 0 if not found
  }
  setVillageNameEn(val: string): void {
    this.VillageNameEn = val;
    this.StorageKey.setItem("VillageNameEn", val); // Store Company reference in local storage
  }
  resetVillageNameEn(): void {
    this.StorageKey.setItem("VillageNameEn", "");
  }


  // ==================================== PHC Mr  ========================================================
  // for PHC
  PHCNameMr: string = "";
  getPHCNameMR(): string {
    // const PHCName = this.StorageKey.getItem("PHCName");
    const PHCNameMr = this.SidebarMenuStateService.getPHCNameMR();
    return PHCNameMr ? PHCNameMr : ""; // Return the Company reference or 0 if not found
  }

  setPHCNameMr(val: string): void {
    this.PHCNameMr = val;
    this.StorageKey.setItem("PHCNameMr", val); // Store Company reference in local storage
  }
  resetPHCNameMr(): void {
    this.StorageKey.setItem("PHCNameMr", "");
  }
  // ==================================== SC Mr  ========================================================

  SCNameMr: string = "";
  getSCNameMR(): string {
    // const SC = this.StorageKey.getItem("SC");
    const SCMr = this.SidebarMenuStateService.getSCNameMR();
    return SCMr ? SCMr : ""; // Return the Company reference or 0 if not found
  }
  setSCNameMr(val: string): void {
    this.SCNameMr = val;
    this.StorageKey.setItem("SCNameMr", val); // Store Company reference in local storage
  }
  resetSCNameMr(): void {
    this.StorageKey.setItem("SCNameMr", "");
  }
  // ==================================== Village Mr  ========================================================
  VillageNameMr: string = "";
  getVillageNameMr(): string {
    // const Village = this.StorageKey.getItem("Village");
    const Village = this.SidebarMenuStateService.getVillageNameMr();
    return Village ? Village : ""; // Return the Company reference or 0 if not found
  }
  setVillageNameMr(val: string): void {
    this.VillageNameMr = val;
    this.StorageKey.setItem("VillageNameMr", val); // Store Company reference in local storage
  }
  resetVillageNameMr(): void {
    this.StorageKey.setItem("VillageNameMr", "");
  }

  // ==================================== UserDisplayName En ========================================================
  UserDisplayNameEn: string = "";
  getUserDisplayNameEN(): string {
    return this.SidebarMenuStateService.getUserDisplayNameEN();
  }
  setUserDisplayNameEn(val: string): void {
    this.UserDisplayNameEn = val;
    this.StorageKey.setItem("UserDisplayNameEn", val);
  }
  resetUserDisplayNameEn(): void {
    this.StorageKey.setItem("UserDisplayNameEn", "");
  }

  // ==================================== UserDisplayName Mr ========================================================
  UserDisplayNameMr: string = "";
  getUserDisplayNameMR(): string {
    return this.SidebarMenuStateService.getUserDisplayNameMR();
  }
  setUserDisplayNameMr(val: string): void {
    this.UserDisplayNameMr = val;
    this.StorageKey.setItem("UserDisplayNameMr", val);
  }
  resetUserDisplayNameMr(): void {
    this.StorageKey.setItem("UserDisplayNameMr", "");
  }

  // ==================================== RoleName En ========================================================
  RoleNameEn: string = "";
  getRoleNameEN(): string {
    return this.SidebarMenuStateService.getRoleNameEN();
  }
  setRoleNameEn(val: string): void {
    this.RoleNameEn = val;
    this.StorageKey.setItem("RoleNameEn", val);
  }
  resetRoleNameEn(): void {
    this.StorageKey.setItem("RoleNameEn", "");
  }

  // ==================================== RoleName Mr ========================================================
  RoleNameMr: string = "";
  getRoleNameMR(): string {
    return this.SidebarMenuStateService.getRoleNameMR();
  }
  setRoleNameMr(val: string): void {
    this.RoleNameMr = val;
    this.StorageKey.setItem("RoleNameMr", val);
  }
  resetRoleNameMr(): void {
    this.StorageKey.setItem("RoleNameMr", "");
  }


   // ExpandedRef  start
  ExpandedRef: number = 0
  getExpandedParentRef(): number {
    const ExpandedRef = this.StorageKey.getItem("ExpandedRef");
    return ExpandedRef ? +ExpandedRef : 0; // Return the Employee reference or 0 if not found
  }
  setExpandedParentRef(val: number): void {
    this.ExpandedRef = val;
    this.StorageKey.setItem("ExpandedRef", val.toString()); // Store Employee reference in local storage
  }
   resetExpandedParentRef(): void {
    this.StorageKey.setItem("ExpandedRef", "");
  }

}


